<template>
  <div class="flex items-center space-x-1" v-if="false">
    <button 
      class="toolbar-btn" 
      :class="{ 'active': editor.isActive({ textAlign: 'left' }) }"
      @click="editor.chain().focus().setTextAlign('left').run()"
      :title="$t('AlignLeft')"
    >
      <i class="fas fa-align-left"></i>
    </button>
    
    <button 
      class="toolbar-btn" 
      :class="{ 'active': editor.isActive({ textAlign: 'center' }) }"
      @click="editor.chain().focus().setTextAlign('center').run()"
      :title="$t('AlignCenter')"
    >
      <i class="fas fa-align-center"></i>
    </button>
    
    <button 
      class="toolbar-btn" 
      :class="{ 'active': editor.isActive({ textAlign: 'right' }) }"
      @click="editor.chain().focus().setTextAlign('right').run()"
      :title="$t('AlignRight')"
    >
      <i class="fas fa-align-right"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AlignmentButtons',
  
  props: {
    editor: {
      type: Object,
      required: true
    }
  }
}
</script> 
